var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconRevenue = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "revenue-icon-white",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "symbols",
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-_-24px-_-blue-_-revenue",
    "data-name": "icons-/-24px-/-blue-/-revenue",
    transform: "translate(5 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dollar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M16.816,16.309a12.782,12.782,0,0,0-2.53-1.067V10a2.857,2.857,0,0,0-2.857-2.857v7.384c-.377-.074-.77-.143-1.184-.22-.6-.1-1.156-.211-1.673-.32V10A2.857,2.857,0,0,0,5.714,7.143v6.064C3.646,12.443,2.857,11.469,2.857,10c0-2.323,3.271-4.286,7.143-4.286S17.143,7.677,17.143,10H20c0-2.9-2.309-5.35-5.714-6.476V0H11.429V2.929c-.466-.046-.943-.071-1.429-.071s-.963.026-1.429.071V0H5.714V3.524C2.309,4.65,0,7.1,0,10c0,5.429,6.107,6.487,9.756,7.121,5.316.924,7.387,2.131,7.387,4.307a4.169,4.169,0,0,1-2.857,3.4v-3.4a2.857,2.857,0,0,0-2.857-2.857v7.053a11.383,11.383,0,0,1-2.857,0V20a2.857,2.857,0,0,0-2.857-2.857V24.83a4.169,4.169,0,0,1-2.857-3.4H0c0,2.9,2.309,5.35,5.714,6.476v3.524H8.571V28.5c.466.046.943.071,1.429.071s.963-.026,1.429-.071v2.929h2.857V27.9C17.691,26.778,20,24.333,20,21.429A5.664,5.664,0,0,0,16.816,16.309Z",
    fill: "#fff"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconRevenue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-revenue.5f0156f7.svg";
export { ForwardRef as ReactComponent };